
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary.tsx'

// Enhanced global error handling
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Log additional information about the error
  console.error('Error message:', event.error?.message);
  console.error('Error stack:', event.error?.stack);
  console.error('Error occurred at:', new Date().toISOString());
  console.error('Environment:', import.meta.env.MODE);
  
  // Add visibility into the DOM state
  console.error('Root element exists:', !!document.getElementById('root'));
  console.error('Body content:', document.body.innerHTML);
  
  // Show a user-friendly error message if the app fails to load
  if (!document.querySelector('.error-fallback')) {
    document.body.innerHTML += `
      <div class="error-fallback" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 10000;">
        <h2>Something went wrong</h2>
        <p>The application encountered an error. Please try refreshing the page.</p>
        <button onclick="window.location.reload()" style="padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 4px; margin-top: 20px; cursor: pointer;">
          Refresh Page
        </button>
      </div>
    `;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  console.error('Promise rejection stack:', event.reason?.stack);
  console.error('Rejection happened at:', new Date().toISOString());
});

// Log initialization info
console.log('Application initializing at:', new Date().toISOString());
console.log('Environment:', import.meta.env.MODE);
console.log('Base URL:', import.meta.env.BASE_URL);
console.log('Browser:', navigator.userAgent);

// Create a function to mount the React app with error handling
function mountReactApp() {
  try {
    // Ensure the root element exists and mount the React app
    let rootElement = document.getElementById("root");
    
    if (!rootElement) {
      console.warn('Root element not found, creating one');
      rootElement = document.createElement('div');
      rootElement.id = 'root';
      document.body.appendChild(rootElement);
    }
    
    console.log('Mounting React app to DOM');
    createRoot(rootElement).render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    );
    console.log('React app successfully mounted to DOM');
  } catch (err) {
    console.error('Failed to render React application:', err);
    // Display a fallback UI if React fails to render
    const rootElement = document.getElementById("root") || document.body;
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h1>Something went wrong</h1>
        <p>We're sorry, but the application failed to load. Please try refreshing the page.</p>
        <button onclick="window.location.reload()" style="padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 4px; margin-top: 20px; cursor: pointer;">
          Refresh Page
        </button>
        <pre style="background: #f1f1f1; padding: 10px; border-radius: 5px; text-align: left; margin-top: 20px;">${err?.message || 'Unknown error'}</pre>
      </div>
    `;
  }
}

// Wait for DOM to be fully loaded before mounting
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountReactApp);
} else {
  mountReactApp();
}
